import { useState, useEffect } from "react";
import { styled as muiStyled } from "@mui/material/styles";

import { Box } from "@mui/material";
import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import Button from "src/components/core/Button";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { ImageCropper } from "./ImageCropper";
import getCroppedImg from "./cropImage";

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 24,
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
    border: 0,
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
}));

const ImageCropperModal = ({ aspectRatio, imageData, onClose, onSubmit }) => {
  const [imageURL, setImageURL] = useState("");
  const [cropped, setCropped] = useState({
    width: 0,
    height: 0,
    x: 0,
    y: 0,
  });

  const handleCropped = (val) => {
    setCropped(val);
  };

  const cropImage = async () => {
    const croppedImage = await getCroppedImg(imageURL, cropped);
    onSubmit(croppedImage);
  };

  const getImageFileFromURL = async (url) => {
    const response = await fetch(url, {
      headers: { "Access-Control-Allow-Origin": "*" },
    });
    return await response.blob();
  };

  useEffect(() => {
    (async () => {
      setImageURL(
        URL.createObjectURL(
          typeof imageData === "string"
            ? await getImageFileFromURL(
                imageData.replace(
                  "https://productimage.xsurface.com",
                  "https://product-xsurface.s3.ap-southeast-1.amazonaws.com"
                )
                // imageData.replace(
                //   "https://devimage.xsurface.com",
                //   "https://devx-test-image.s3.ap-southeast-1.amazonaws.com"
                // )
              )
            : imageData
        )
      );
    })();
  }, [imageData]);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 768,
          },
        },
      }}
    >
      <DialogTitle>
        แก้ไขรูปภาพ
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            paddingTop: "100%",
          }}
        >
          {imageURL && (
            <ImageCropper
              aspectRatio={aspectRatio}
              imageURL={imageURL}
              onCropComplete={(_, val) => handleCropped(val)}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          size="large"
          onClick={onClose}
          sx={{ minWidth: 140 }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          sx={{ minWidth: 140 }}
          onClick={cropImage}
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageCropperModal;
